import { useState } from "react";
import "../index.css";
import Footer from "../components/Footer";
import { PageNav } from "../components/PageNav";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/context";
import ApiCall from "../auth/ApiCall";
import buttonBackground from "../assets/button_background_blue.webp";
import buttonBackgroundRed from "../assets/button_background_red.webp";

export default function DeleteAccount() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [confirmText, setConfirmText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleDelete = async () => {
    if (confirmText !== "DELETE") {
      setError('Please type "DELETE" to confirm.');
      return;
    }

    setIsLoading(true);
    setError("");

    const response = (await ApiCall.makeAuthenticatedRequest(
      "/accounts/api/user/delete/",
      { method: "POST" },
    )) as { error?: string; message?: string };

    if (response.error) {
      setError(response.error);
      setIsLoading(false);
      return;
    }

    localStorage.clear();
    await logout();
    navigate("/");
  };

  return (
    <div>
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-overlay-spinner"></div>
        </div>
      )}
      <PageNav />
      <div className="form-container" style={{ marginTop: 100 }}>
        <div className="form-content">
          <div className="center_me">
            <h2
              className="font_family_base header_text"
              style={{ fontSize: 28, fontWeight: "bold", margin: 0 }}
            >
              Delete Account
            </h2>
          </div>

          <div
            style={{
              marginTop: 20,
              marginBottom: 20,
              padding: "15px 20px",
              backgroundColor: "#1a0000",
              borderRadius: 8,
              border: "1px solid #ff4444",
            }}
          >
            <p className="font_family_base" style={{ color: "#ff6b6b", fontWeight: "bold", marginBottom: 8 }}>
              Warning: This action cannot be undone.
            </p>
            <p className="font_family_base" style={{ color: "#ccc", fontSize: 14, lineHeight: 1.6 }}>
              Requesting account deletion will:
            </p>
            <ul className="font_family_base" style={{ color: "#ccc", fontSize: 14, lineHeight: 1.8, paddingLeft: 20 }}>
              <li>Cancel any active subscription</li>
              <li>Remove all your alerts and rules</li>
              <li>Permanently delete your account data</li>
            </ul>
            <p className="font_family_base" style={{ color: "#ccc", fontSize: 14, lineHeight: 1.6, marginTop: 8 }}>
              If you have an active subscription, please cancel it first to avoid future charges.
            </p>
          </div>

          {error && (
            <div
              className="font_family_base error_text_color"
              style={{
                padding: "13px",
                borderRadius: "8px",
                textAlign: "center",
                border: "1px solid #FF0000",
                marginBottom: 16,
              }}
            >
              {error}
            </div>
          )}

          <label className="font_family_base field-name field_name_color">
            Type DELETE to confirm:
          </label>
          <input
            className="font_family_base input"
            style={{ marginBottom: 20 }}
            type="text"
            placeholder="DELETE"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            autoComplete="off"
            disabled={isLoading}
          />

          <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
            <button
              className="my-form-button button-base button-3d font_family_base"
              onClick={() => navigate("/settings")}
              disabled={isLoading}
              style={{
                backgroundImage: `url(${buttonBackground})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
              }}
            >
              Cancel
            </button>
            <button
              className="my-form-button button-base button-3d font_family_base"
              onClick={handleDelete}
              disabled={isLoading || confirmText !== "DELETE"}
              style={{
                backgroundImage: `url(${buttonBackgroundRed})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "white",
                fontWeight: 700,
                opacity: confirmText !== "DELETE" ? 0.5 : 1,
              }}
            >
              Delete My Account
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
